export const AppRoutes = {
    callback: '/callback',
    loggedOut: '/logged-out',
    home: '/home',
    requests: '/requests',
    requestDetails: (payerId = ':payerId', requestId = ':requestId') =>
        `/requests/${payerId}/${requestId}`,
    termsOfUse: '/terms-of-use',
    privacyPolicy: '/privacy-policy',
    updatesHistory: '/updates-history',
} as const;
